import { render, staticRenderFns } from "./BlockUser.vue?vue&type=template&id=4cf83546&scoped=true"
import script from "./BlockUser.vue?vue&type=script&lang=js"
export * from "./BlockUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf83546",
  null
  
)

export default component.exports